import * as types from './mutations_types'

export const saveProfile = (context, member) => context.commit(types.SET_MEMBER, member)

export const saveNotification = (context, notification) => context.commit(types.SAVE_NOTIFICATION, notification)

export const setNotifications = (context, notifications) => context.commit(types.SET_NOTIFICATIONS, notifications)

export const savePreferences = (context, preferences) => context.commit(types.SET_PREFERENCES, preferences)

export const setIntegrations = (context, integrations) => context.commit(types.SET_INTEGRATIONS, integrations)



// WEBPACK FOOTER //
// ./src/modules/profile/store/actions.js